import { Button } from "@repo/ui/components/ui/button";
import { Check } from "lucide-react";
import { useScheduleSessionsContext } from "./use-schedule-sessions-context";

/** Footer dispatches to an explicit per-step variant — no inline mode branching. */
export function ScheduleSessionsFooter() {
  const { state } = useScheduleSessionsContext();
  return (
    <div className="flex shrink-0 items-center justify-between border-t px-5 py-3">
      {state.mode === "review" ? <ReviewFooter /> : <SchedulingFooter />}
    </div>
  );
}

function SchedulingFooter() {
  const { state, actions } = useScheduleSessionsContext();
  const { allAssigned, placedCandidate, activeSession, assignments, busy } = state;
  // A placement is "dirty" (needs confirming) when it differs from what's already
  // committed for the active session — so editing an assigned session re-shows Confirm.
  const committed = activeSession ? assignments[activeSession.orderSetId]?.candidate : undefined;
  const dirty = !!placedCandidate && placedCandidate !== committed;
  return (
    <>
      <Button variant="ghost" size="sm" disabled={busy} onClick={() => actions.setOpen(false)}>
        Cancel
      </Button>
      <div className="flex items-center gap-2">
        {allAssigned && !dirty ? (
          <Button size="sm" onClick={actions.goToReview}>
            Review schedule →
          </Button>
        ) : (
          <Button size="sm" disabled={!dirty} onClick={actions.confirmActive}>
            Confirm & next →
          </Button>
        )}
      </div>
    </>
  );
}

function ReviewFooter() {
  const { state, actions } = useScheduleSessionsContext();
  const { sessions, busy } = state;
  return (
    <>
      <Button variant="ghost" size="sm" disabled={busy} onClick={actions.backToScheduling}>
        ← Edit
      </Button>
      <Button
        size="sm"
        disabled={busy}
        className="bg-success text-success-foreground hover:bg-success/90 gap-1.5"
        onClick={actions.book}
      >
        <Check className="size-3.5" strokeWidth={2.5} />
        {busy ? "Booking…" : `Book ${sessions.length} session${sessions.length !== 1 ? "s" : ""}`}
      </Button>
    </>
  );
}
